import http from '../httpService';
import apiConfig from '../../utils/config.json';

const apiEndPoint = `${apiConfig.apiUrl}executiveLevel/get/allCentersWithPerformance`;

export function getAllPerformance(value) {
  const obj = {
    page: value.page,
    limit: value.limit,
    filter: {}
  };
  return http.post(apiEndPoint, obj);
}


export default {
    getAllPerformance,

}

